jQuery(document).ready(function (e) {
    var sidebar_childs = e("#sidebar aside").children().length;
    if (sidebar_childs === 0) {
        e('#content').css('width', '100%');
        e('#sidebar').css('width', '0');
    }

});
